import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getRacingConfig() {
    return {
        custom: {
            [PALETTE_IDS.RACING]: {
                RaceCardInfo: {
                    _mobile_displayTrackNameAndRaceTime: true,
                },
            },
            [PALETTE_IDS.RACE_MEETINGS]: {
                RaceMeeting: {
                    description: {
                        style: {
                            _mobile_alignItems: 'center',
                        },
                    },
                    bestOddsGuaranteed: {
                        hideablePane: {
                            style: {
                                base: {
                                    _mobile_padding: '0 0 8px 8px',
                                },
                            },
                        },
                    },
                },
            },
        },

        palette: {
            [PALETTE_IDS.RACE_CARD]: {
                // info with description
                RACE_CARD_INFO_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                RACE_CARD_INFO_TITLE_TEXT: {
                    fontFamily: FONT.FAMILY_SECOND,
                    color: COLOR.BRAND.ACCENT2,
                    fontSize: FONT.SIZE_XSMALL,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                RACE_CARD_INFO_DISTANCE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_XSMALL,
                },
                RACE_CARD_INFO_RUNNERS_AMOUNT_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontSize: FONT.SIZE_XSMALL,
                },
                RACE_CARD_INFO_STREAMING_INDICATOR: {
                    INDICATOR_ICON_COLOR: COLOR.BRAND.BACKGROUND1,
                },
                RACE_CARD_RUNNERS_TABLE: {
                    TABLE_HEADER_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontSize: FONT.SIZE_SMALL,
                    },
                    TABLE_ITEM_TEXT: {
                        color: COLOR.BRAND.FOREGROUND2,
                        fontSize: FONT.SIZE_MEDIUM,
                    },
                    TABLE_HEADER_SORT_BUTTON_TEXT: COLOR.BRAND.CTA2,
                    TABLE_HEADER_SORT_BUTTON_ICON_SRC: 'sort-desc-smooth-edges',
                },
                RACE_CARD_DEDUCTIONS_TITLE_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                RACE_CARD_NON_RUNNERS_NAMES_LIST_TEXT: COLOR.BRAND.FOREGROUND2,
                RACE_CARD_CAST_MARKETS_TABLE: {
                    TABLE_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                    TABLE_HEADER_TEXT: {
                        fontSize: FONT.SIZE_SMALL,
                        color: COLOR.BRAND.FOREGROUND2,
                    },
                },
                RUNNER_POSITION_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                RACE_CARD_BEST_ODDS_GUARANTEED_INDICATOR: {
                    BEST_ODDS_GUARANTEED_INDICATOR_LABEL_TEXT: {
                        fontWeight: FONT.WEIGHT_NORMAL,
                        color: COLOR.BRAND.FOREGROUND4,
                    },
                },
            },
            [PALETTE_IDS.FUTURE_RACING]: {
                FUTURE_RACE_CARD_DATE_CONTAINER_BG: COLOR.BRAND.FOREGROUND5,
                FUTURE_RACE_CARD_DATE_TEXT: COLOR.BRAND.ACCENT2,
                FUTURE_RACE_CARD_EVENT_NAME_CONTAINER_BG: COLOR.BRAND.FOREGROUND5,
                FUTURE_RACE_CARD_EVENT_NAME_TEXT: {
                    fontSize: FONT.SIZE_XSMALL,
                    color: COLOR.BRAND.ACCENT2,
                    fontFamily: FONT.FAMILY_SECOND,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                FUTURE_RACE_CARD_EW_TERMS_TEXT: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.RACE_MEETINGS]: {
                RACE_MEETINGS_HEADER_BG: COLOR.BRAND.BACKGROUND4,
                RACE_MEETINGS_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontSize: FONT.SIZE_XSMALL,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontFamily: FONT.FAMILY_SECOND,
                },
                RACE_MEETINGS_LIVE_RACE_ICON_COLOR: COLOR.BRAND.CTA2,
                RACE_MEETINGS_PANE_ICON_COLOR: COLOR.BRAND.BACKGROUND1,
                RACE_MEETINGS_RACE_BUTTON: {
                    TOGGLE_BUTTON_TEXT: COLOR.BRAND.CTA2,
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND5,
                },
                RACE_MEETING_MOBILE_PAGE_HEADER_CONTAINER_BG: COLOR.BRAND.BACKGROUND7,
                RACE_MEETING_MOBILE_RACE_TIME_SELECTOR_BG: COLOR.BRAND.BACKGROUND7,
                RACE_MEETING_BEST_ODDS_GUARANTEED_INDICATOR: {
                    BEST_ODDS_GUARANTEED_INDICATOR_LABEL_TEXT: {
                        fontWeight: FONT.WEIGHT_NORMAL,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                },
            },
        },
    };
}
